import React, { useContext, useEffect, useState } from "react";
import zohoLogo from "../../images/zoho_logo.png";
import Swal from "sweetalert2";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function ExZohoBtn({
  expert_id,
  in_zoho,
  status,
  summLength,
  setShowSummAlert,
  exObject,
  project_id,
}) {
  const [isDisabled, setIsDisabled] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [inZoho, setInZoho] = useState("");
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    setInZoho(in_zoho);
  }, [in_zoho]);

  useEffect(() => {
    if (status === "0") {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [status]);

  const updateToZohoHandler = () => {
    if (summLength > 2000) {
      setShowSummAlert(true);
      return;
    } else {
      setShowSummAlert(false);
    }
    setUpdateLoading(true);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}update-to-zoho`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ expert_id: expert_id, project_id: project_id }),
    })
      .then((res) => res.json())
      .then((data) => {
        setUpdateLoading(false);
        if (data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Expert has been updated to Zoho",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
  };

  const addToZohoHandler = () => {
    if (summLength > 2000) {
      setShowSummAlert(true);
      return;
    } else {
      setShowSummAlert(false);
    }
    if (exObject.expertEmail === "email@email.com") {
      setInvalidEmail(true);
      setTimeout(() => {
        setInvalidEmail(false);
      }, 6000);
      return;
    } else {
      setInvalidEmail(false);
    }
    setAddLoading(true);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}add-to-zoho`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ expert_id: expert_id, project_id: project_id }),
    })
      .then((res) => res.json())
      .then((data) => {
        setAddLoading(false);
        if (data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Expert has been added to Zoho",
            showConfirmButton: false,
            timer: 1500,
          });
          setInZoho("yes");
        } else if (data.status === "profile already in zoho") {
          Swal.fire({
            icon: "info",
            title:
              "Profile already exists in zoho. Do you want to update the existing profile?",
            showConfirmButton: true,
            confirmButtonText: "Yes",
            showCancelButton: true,
            cancelButtonText: "No",
            // timer: 1500
          }).then((result) => {
            if (result.isConfirmed) {
              setUpdateLoading(true);
              const tokenObj = localStorage.getItem("eph-token");
              const token = JSON.parse(tokenObj).value;
              const url = `${API_URL}update-existing-to-zoho`;
              fetch(url, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "x-access-token": token,
                },
                body: JSON.stringify({
                  expert_id: expert_id,
                  project_id: project_id,
                }),
              })
                .then((res) => res.json())
                .then((data) => {
                  setUpdateLoading(false);
                  if (data.status === "success") {
                    Swal.fire({
                      icon: "success",
                      title: "Expert has been updated to Zoho",
                      showConfirmButton: true,
                      //   timer: 1500
                    });
                    window.location.reload(true);
                  } else {
                    Swal.fire({
                      icon: "error",
                      title: "Something went wrong",
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  }
                });
            }
            //  else{
            //      window.location.reload(true);
            //  }
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
  };

  return (
    <>
      {inZoho === "yes" ? (
        <button className="btn btn-zoho2" onClick={updateToZohoHandler}>
          <i className="fa-solid fa-arrow-up-from-bracket" /> Update to{" "}
          <img
            width="40px"
            src={zohoLogo}
            style={{ marginBottom: "6px" }}
            alt="zoho"
          />
        </button>
      ) : (
        <>
          {invalidEmail && (
            <span className="prjdetails-email-alert">Invalid email</span>
          )}
          <button
            className="btn btn-zoho1"
            disabled={isDisabled}
            onClick={addToZohoHandler}
          >
            <i className="fa-solid fa-user-plus" /> Add to{" "}
            <img
              width="40px"
              src={zohoLogo}
              style={{ marginBottom: "6px" }}
              alt="zoho"
            />
          </button>
        </>
      )}

      {updateLoading && (
        <div className="updateToZoho-popup-wrapper">
          <div className="tab-pane fade show updateToZoho-div">
            <center>
              <p style={{ fontSize: "18px" }}>Updating data...</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
      {addLoading && (
        <div className="updateToZoho-popup-wrapper">
          <div className="tab-pane fade show updateToZoho-div">
            <center>
              <p style={{ fontSize: "18px" }}>Adding data...</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
